/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/indent */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getFormPropertiesSelector, getFormDataSelector } from '../FormStore/Selectors/FormDataSelectors';
import { submitVerification } from '../FormStore/Actions/FormServiceActions/DigitalLicenceServiceActions/VerificationSubmissionAction';
import { SUBMISSION_SUCCESS } from '../FormStore/Actions/FormServiceActions/GenericFormServiceActions/SubmissionAction';
import { clearPageAlert } from '../PortalStore/Actions/PageAlertActions';
import { getB2cSettingsSelector } from '../PortalStore/Selectors/SystemSettingSelectors';

import Question from '../components/CASAForm/Question';
import Step from '../components/CASAForm/Step';
import Application from '../components/CASAForm/Application';

import CASASpinner from '../components/Portal/CASASpinner';

class DigitalLicenceVerification extends Component {
    constructor (props) {
        super(props);

        this.state = {
            applicationSubmitting: false,
            declaration: null,
            passHash: null
        };
    }

    componentDidMount = () => {
        this.props.dispatch(clearPageAlert());

        this.parseUrlParams();
    }

    componentDidUpdate (prevProps) {
        if (this.props.formProperties.submitForm &&
            prevProps.formProperties.submitForm !== this.props.formProperties.submitForm) {
            this.submitForm();
        }
    }

    parseUrlParams() {
        let urlParams = queryString.parse(window.location.search);

        if (!urlParams) {
            return;
        }

        this.setState({
            passHash: urlParams.passHash
        })       
    }

    returnDeclaration = (questionObject) => {
        this.setState({
            declaration: questionObject.answer
        });
    }

    submitForm = () => {
        this.setState({ applicationSubmitting: true });
        const webappurlForms = this.props.b2cSettings.webappurlFormsApi;

        this.props.dispatch(
            submitVerification(webappurlForms, this.props.b2cSettings.accesstokenForms, this.props.formProperties, this.props.formData, this.state.passHash)
        )
            .then(response => {
                if (response.type === SUBMISSION_SUCCESS) {
                    this.setState({ applicationSubmitting: false });
                    if(response.payload.passDetails.passType === 'AEL') {
                        let portalSetting = this.props.envdata.items.systemsettings.value.find(systemSetting => systemSetting.casa_name === 'Portal - Home URL');
                        var loc = portalSetting.casa_stringvalue +`/forms/licencesandauthorisations/aircraft-engineer-licence-details/scanned/${response.payload.passDetails.holderAviationReferenceNumber}`;
                        window.location.href = loc;
                    }
                    else {
                        this.props.history.push(`/digitallicence/verification/verification-view/${response.payload.verificationToken}/${response.payload.passDetails.passType}`);
                    }
                }
                else {
                    this.setState({ applicationSubmitting: false });
                    this.props.history.push('/digitallicence/verification/verification-view/');
                }
            });
    }

    render = () => {

        return (
            <Fragment>

                {this.state.applicationSubmitting && <CASASpinner message='Submitting form' />}
                <Application
                    formInformation={{
                        id: 'digitalLicenceVerificationForm',
                        name: 'Confirm authorisation',
                        formCode: 'DIG_LIC_VERIFICATION',
                        rootFormCode: 'DIG_LIC',
                        version: '01',
                        formDataType: 'genericFormData',
                    }}
                    enableSaveButton={false}
                    showback={false} >

                    <Step
                        id="verifyDigitalLicence"
                        stepTitle=""
                        initialStep
                        isLastStep
                        formSubmission={this.submitForm}
                        showback={true}
                        backurl='/forms/digitallicence/verification'
                    >
                        <Question
                            id="declaration"
                            stepid="verifyDigitalLicence"
                            key="declaration"
                            type="declaration"
                            name="declaration"
                            label="I agree and understand the above conditions."
                            value="declaration"
                            showError={this.state.validateFail}
                            returnQuestionData={this.returnDeclaration}>
                            <>
                                <p>I declare that the QR code of the authorisation I seek a digital view of was obtained from the authorisation holder.</p>
                                <p>I understand and acknowledge that to knowingly make a false or misleading declaration is an offence against the Criminal Code Act 1995 (Cth).</p>
                            </>
                        </Question>
                    </Step>
                </Application>
            </Fragment>
        );
    }
}

DigitalLicenceVerification.propTypes = {
    dispatch: PropTypes.func,
    envdata: PropTypes.object,
    formProperties: PropTypes.object,
    formData: PropTypes.object,
    b2cSettings: PropTypes.object,
    user: PropTypes.object,
    history: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        user: state.userdetails,
        envdata: state.envdata,
        pageAlert: state.pageAlert,
        formProperties: getFormPropertiesSelector(state.formStore),
        formData: getFormDataSelector(state.formStore, 'genericFormData'),
        b2cSettings: getB2cSettingsSelector(state.B2CSettings, ['webappurlFormsApi', 'accesstokenForms', 'parsed']),
    };
};

export default withRouter(connect(mapStateToProps)(DigitalLicenceVerification));